import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalHeader: {
        display: "flex",
        alignItems: "center",
        padding: "16px 24px",
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    modalBody: {
        padding: "24px",
        display: "flex",
        flexDirection: "column",
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: "16px 24px",
        gap: "16px",
        justifyContent: "flex-end",
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    section: {
        display: "flex",
        gap: "32px",
        width: "100%",
        "& .MuiChip-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700",
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.info.main,
        },
    },
    modalBodyLeft: {
        display: "flex",
        flexDirection: "column",
    },
    modalBodyRight: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "20px",
        width: "100%",
    },
    avatar: {
        width: `120px !important`,
        height: `120px !important`,
    },
    item: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "12px",
        textTransform: "uppercase",
        color: theme.palette.primary.dark,
    },
    value: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "14px",
        color: theme.palette.text.secondary,
    },
    userImageActionWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "8px",
    },
    userImageAction: {
        fontSize: "12px !important",
        fontWeight: `700 !important`,
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "792px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
